import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import FrontLayout from './layouts/FrontendLayout';
import About from './Pages/Frontend/About';
import Home from './Pages/Frontend/Home';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './Pages/Admin/Dashboard';
import User from './Pages/Admin/User';
import Booking from './Pages/Admin/Booking';
import AddBooking from './Pages/Admin/AddBooking';
import Payment from './Pages/Frontend/Payment';
import BookingStatus from './Pages/Frontend/BookingStatus';
import CheckAvailability from './Pages/Frontend/CheckAvailability';
import Faq from './Pages/Admin/Faq';
import EditFaq from './Pages/Admin/EditFaq';
import CreateFaq from './Pages/Admin/CreateFaq';
import UserCreate from './Pages/Admin/UserCreate';
import Mandap from './Pages/Admin/Mandap';
import CreateMandap from './Pages/Admin/CreateMandap';
import EditMandap from './Pages/Admin/EditMandap';
import CreatePurpose from './Pages/Admin/CreatePurpose';
import EditPurpose from './Pages/Admin/EditPurpose';
import Purpose from './Pages/Admin/Purpose';
import BookingAccountInfo from './Pages/Admin/BookingAccountInfo';
import CancelBooking from './Pages/Frontend/CancelBooking';
import AdminLogin from './Pages/Admin/auth/AdminLogin';
import ProtectedRoute from './Components/Admin/ProtectedRoute';
import UserEdit from './Pages/Admin/UserEdit';
import FrontendLogin from './Pages/Frontend/FrontendLogin';
import Profile from './Pages/Frontend/Profile';
import Settings from './Pages/Admin/Settings';



function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Frontend Routes */}
        <Route path="/" element={<FrontLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="/payment/:ref_no" element={<Payment />} />
          <Route path="/booking-status/:ref_no" element={<BookingStatus />} />
          <Route path="/check-availability/" element={<CheckAvailability />} />
          <Route path="/cancel-booking" element={<CancelBooking />} />
          <Route path="login" element={<FrontendLogin />} />  {/* ✅ add this */}
          <Route path="profile" element={<Profile />} />
        </Route>

        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Admin Routes */}
        <Route path="admin" element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        } >
          <Route index element={<Dashboard />} />
          <Route path='users' element={<User />} />
          <Route path='bookings' element={<Booking />} />
          <Route path='add-bookings' element={<AddBooking />} />
          <Route path='faq' element={<Faq />} />
          <Route path="faq/edit/:id" element={<EditFaq />} />
          <Route path="faq/create" element={<CreateFaq />} />
          <Route path="users" element={<User />} />

          <Route path="users/create" element={<UserCreate />} />
          <Route path="users/:id/edit" element={<UserEdit />} />

          {/* <Route path="users/edit/:id" element={<EditUser />} /> */}

          <Route path="mandaps" element={<Mandap />} />

          <Route path="mandaps/create" element={<CreateMandap />} />

          <Route path="mandaps/edit/:id" element={<EditMandap />} />
          <Route path="purposes" element={<Purpose />} />

          <Route path="purposes/create" element={<CreatePurpose />} />

          <Route path="purposes/edit/:id" element={<EditPurpose />} />
          <Route path="booking-account-info" element={<BookingAccountInfo />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
